import { render, staticRenderFns } from "./AppStatusIndicator.vue?vue&type=template&id=6faaf872"
import script from "./AppStatusIndicator.vue?vue&type=script&lang=js"
export * from "./AppStatusIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports